import { createUseStyles } from 'react-jss'

export const style = {
  label: {
    fontWeight: 'bold'
  },
  image: {
    maxWidth: 1024
  }
}

export const useStyles = createUseStyles(style)
